export const DEFAULT_CERTIFICATION_SLOT_TIME = '09:00'

export function createCertificationSlotInput(time, enrolmentId = null) {
  return {
    time,
    occupied: enrolmentId != null,
    enrolmentId: enrolmentId ?? null,
  }
}

export function getCertificationSlotTime(slot) {
  if (typeof slot === 'string') {
    return slot
  }
  return slot?.time ?? ''
}

export function isCertificationSlotOccupied(slot) {
  if (typeof slot === 'string') {
    return false
  }
  return slot?.enrolmentId != null || !!slot?.occupied
}

export function normalizeCertificationSlotInputs(slotTimeInputs) {
  if (!Array.isArray(slotTimeInputs)) {
    return []
  }
  return slotTimeInputs.map(slot => {
    if (typeof slot === 'string') {
      return createCertificationSlotInput(slot)
    }
    return createCertificationSlotInput(slot.time ?? '', slot.enrolmentId ?? null)
  })
}

export function formatPriceFromGrosze(priceInGrosze) {
  return (priceInGrosze / 100)
    .toFixed(2)
    .toString()
    .replace('.', ',')
}

export function parsePriceToGrosze(value) {
  let formatted = parseFloat(String(value).replace(',', '.')).toFixed(2)
  if (formatted === 'NaN') {
    formatted = '0.00'
  }
  return Math.round(parseFloat(formatted) * 100)
}

export function addCertificationSlot(slotTimeInputs, time = DEFAULT_CERTIFICATION_SLOT_TIME) {
  const slots = normalizeCertificationSlotInputs(slotTimeInputs)
  return [...slots, createCertificationSlotInput(time)]
}

export function removeCertificationSlot(slotTimeInputs, index) {
  const slots = normalizeCertificationSlotInputs(slotTimeInputs)
  if (slots.length <= 1 || index < 0 || index >= slots.length) {
    return slots
  }
  if (isCertificationSlotOccupied(slots[index])) {
    return slots
  }
  return slots.filter((_, i) => i !== index)
}

export function certificationFormHasEnrolments(mode, takenSlotsCount) {
  return mode === 'edit' && takenSlotsCount > 0
}

export function normalizeCertificationDealers(dealers) {
  if (!dealers || !dealers.length) {
    return dealers || []
  }
  if (typeof dealers[0] === 'object') {
    return dealers.map(d => d['@id'])
  }
  return dealers
}

export function ensureDefaultSlotTimes(slotTimeInputs) {
  return normalizeCertificationSlotInputs(slotTimeInputs)
}

export function computeMaterialsUploadProgress(uploading, informationCount, reportCount) {
  const length = informationCount + reportCount
  if (!length) {
    return 0
  }
  return (Math.abs(uploading - length) / length) * 100
}
